<div class="container-fluid main-card">
    <div class="row align-items-center hide-mobile">
        <div class="col-12">
            <h1>
                Mes favoris
                <span>Organisez vos projets et simulations</span>
            </h1>
        </div>
    </div>

    <!-- Sélecteur de liste + actions -->
    <div class="row favorite-toolbar mb-4 pb-md-3 mt-3 mt-md-0">
        <div class="col-lg-3 col-md-7 favorite-select pe-0">
            <button #listBtn class="btn btn-list-selector" [matMenuTriggerFor]="listMenu" #listTrigger="matMenuTrigger"
                    (click)="listSearchText = ''">
                {{ favoritesList.title }}
                <i class="fa fa-chevron-down"></i>
            </button>
            <mat-menu #listMenu="matMenu" class="list-selector-menu mobile-sheet" backdropClass="mobile-sheet-backdrop">
                <div class="list-menu-content" [style.min-width.px]="listBtn.offsetWidth" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <div class="list-menu-search">
                        <i class="fa fa-search"></i>
                        <input type="text" placeholder="Rechercher..." [(ngModel)]="listSearchText">
                    </div>
                    <div class="list-menu-items">
                        <a *ngFor="let list of filteredListFavorite"
                           class="list-menu-item"
                           [class.active]="'' + list.id === '' + currentList"
                           (click)="currentList = list.id; changeList(); listTrigger.closeMenu()">
                            <ng-container *ngIf="list.share == true">👥 - </ng-container>
                            {{ list.title }}
                        </a>
                    </div>
                    <div class="list-menu-footer">
                        <button class="btn btn-outline w-100"
                                (click)="trackingService.click('favorite_list_new', favoritesList.id);openNewDialog()">
                            + Nouvelle liste
                        </button>
                    </div>
                </div>
            </mat-menu>
        </div>

        <!-- Actions MOBILE : Éditer (mat-menu -> popup + backdrop, cohérent avec le sélecteur de liste) -->
        <div class="favorite-actions ps-2 visible-mobile">
            <button class="btn btn-outline mobile-icon"
                    (click)="trackingService.click('favorite_list_edit', currentList)"
                    [matMenuTriggerFor]="editMobileMenu" #editMobileTrigger="matMenuTrigger">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <mat-menu #editMobileMenu="matMenu" class="mobile-sheet edit-sheet-menu" backdropClass="mobile-sheet-backdrop">
                <div class="edit-menu-owner" *ngIf="favoritesList.share == true" (click)="$event.stopPropagation()">
                    <ng-container *ngIf="isOwner">Vous êtes le propriétaire de cette liste partagée</ng-container>
                    <ng-container *ngIf="!isOwner">{{ favoritesList.owner_name }} est le propriétaire de cette liste partagée</ng-container>
                </div>
                <button mat-menu-item *ngIf="!isAllList" [disabled]="!isOwner"
                        (click)="trackingService.click('favorite_list_rename', favoritesList.id);openRenameDialog()">
                    <i class="fa cfa cfa-pencil"></i>
                    <span>Renommer la liste</span>
                </button>
                <button mat-menu-item *ngIf="!isAllList"
                        (click)="trackingService.click('favorite_list_order', favoritesList.id);orderList()">
                    <i class="fa cfa cfa-sort"></i>
                    <span>Réorganiser vos listes</span>
                </button>
                <button mat-menu-item *ngIf="!isAllList && user.pro_plan != ''" [disabled]="!isOwner"
                        (click)="trackingService.click('favorite_list_share', favoritesList.id);openShareDialog()">
                    <i class="fa fa-share"></i>
                    <span>Partager la liste</span>
                </button>
                <button mat-menu-item
                        (click)="trackingService.click('favorite_list_new', favoritesList.id);openNewDialog()">
                    <i class="fa fa-plus"></i>
                    <span>Nouvelle liste</span>
                </button>
                <button mat-menu-item
                        (click)="trackingService.click('favorite_list_indicateur', favoritesList.id);displayColumsSelection()">
                    <i class="fa cfa cfa-sliders"></i>
                    <span>Indicateurs</span>
                </button>
                <button mat-menu-item [class.text-danger]="isOwner" *ngIf="!isAllList && listFavorite.length > 1" [disabled]="!isOwner"
                        (click)="trackingService.click('favorite_list_delete', favoritesList.id);deleteFavoriteList()">
                    <i class="fa cfa cfa-trash"></i>
                    <span>Supprimer cette liste</span>
                </button>
            </mat-menu>
        </div>

        <div class="col-lg-4 col-md-5 col-6 ps-2 dropdown dropend text-lg-start text-end hide-mobile" *ngIf="!isAllList">
            <button class="btn btn-outline mobile-icon" id="dropdownEdit"
                    (click)="trackingService.click('favorite_list_edit', currentList)"
                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    [stepContent]="listDropdownStepContent"
                    [joyrideStep]="'listDropdownStep'"
                    (next)="displayColumsSelection();">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <div id="editDropdown" class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownEdit"
                 aria-haspopup="true"
                 aria-expanded="false">
                <ul class="pictoList">
                    <li>
                        <a (click)="trackingService.click('favorite_list_rename', favoritesList.id);openRenameDialog()">
                            <i class="fa cfa cfa-pencil"></i>
                            Renommer la liste
                        </a>
                    </li>
                    <li>
                        <a (click)="trackingService.click('favorite_list_order', favoritesList.id);orderList()">
                            <i class="fa cfa cfa-sort"></i>
                            Réorganiser vos listes
                        </a>
                    </li>
                    <li *ngIf="user.pro_plan != ''">
                        <a (click)="trackingService.click('favorite_list_share', favoritesList.id);openShareDialog()">
                            <i class="fa fa-share"></i>
                            Partager la liste
                        </a>
                    </li>
                    <li>
                        <a (click)="trackingService.click('favorite_list_indicateur', favoritesList.id);displayColumsSelection()">
                            <i class="fa cfa cfa-sliders"></i>
                            Indicateurs
                        </a>
                    </li>
                    <li *ngIf="listFavorite.length > 1" class="delete">
                        <a (click)="trackingService.click('favorite_list_delete', favoritesList.id);deleteFavoriteList()">
                            <i class="fa cfa cfa-trash"></i>
                            Supprimer cette liste
                        </a>
                    </li>
                </ul>
            </div>

            <a class="btn btn-outline ms-2 mobile-icon"
               (click)="trackingService.click('favorite_list_new', favoritesList.id);openNewDialog()">
                <i class="fa fa-plus"></i>
                <span>Nouvelle liste</span>
            </a>
        </div>
        <div class="col-lg-4 col-md-5 col-6 ps-2 dropdown dropend text-lg-start text-end hide-mobile" *ngIf="isAllList">
            <button class="btn btn-outline mobile-icon" id="dropdownEdit"
                    (click)="trackingService.click('favorite_list_edit', currentList)"
                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    [stepContent]="listDropdownStepContent"
                    [joyrideStep]="'listDropdownStep'"
                    (next)="displayColumsSelection();">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <div id="editDropdown" class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownEdit"
                 aria-haspopup="true"
                 aria-expanded="false">
                <ul class="pictoList">
                    <li>
                        <a (click)="trackingService.click('favorite_list_indicateur', favoritesList.id);displayColumsSelection()">
                            <i class="fa cfa cfa-sliders"></i>
                            Indicateurs
                        </a>
                    </li>
                </ul>
            </div>

            <a class="btn btn-outline ms-2 mobile-icon"
               (click)="trackingService.click('favorite_list_new', favoritesList.id);openNewDialog()">
                <i class="fa fa-plus"></i>
                <span>Nouvelle liste</span>
            </a>
        </div>
        <div class="col-lg-5 col-12 text-end hide-mobile">
            <div class="d-inline-block">
                <a class="btn btn-outline mobile-icon"
                   *ngIf="authenticationService.isAllowed('essentiel')"
                   (click)="trackingService.click('favorite_list_compare', favoritesList.id);"
                   [routerLink]="['/app/favorites/compare']"
                   [stepContent]="compareStepContent"
                   joyrideStep="compareStep">
                    <i class="fa fa-table"></i>
                    Comparer mes projets
                </a>
                <button class="btn btn-outline mobile-icon"
                        *ngIf="!authenticationService.isAllowed('essentiel')"
                        (click)="upgradePlan('assets/upgrade/compare.png', 'Comparaison entre projets', 'Essentiel')">
                    <i class="fa fa-table"></i>
                    <span>Comparer mes projets</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Compteur + Indicateurs + Tri -->
    <div class="row resultRow favorite-subheader mt-0 mt-md-5 mt-lg-3 mb-3 mb-lg-3">
        <div class="col-12 col-md-8 col-lg-9">
            <h2>
                <ng-container *ngIf="total > 1 && loading == false">
                    <b class="text-primary">{{ total | number }}</b> Annonces enregistrées
                </ng-container>
                <ng-container *ngIf="total == 1 && loading == false">
                    <b class="text-primary">1</b> Annonce enregistrée
                </ng-container>
                <ng-container *ngIf="total == 0 && loading == false">
                    Aucune annonce enregistrée
                </ng-container>
                <ng-container *ngIf="favoritesList.share == true">
                    <span class="share-info hide-mobile">
                        <ng-container *ngIf="favoritesList.user_id == user.id">
                            Vous êtes le propriétaire de cette liste partagée
                        </ng-container>
                        <ng-container *ngIf="favoritesList.user_id != user.id">
                            {{ favoritesList.owner_name }} est le propriétaire de cette liste partagée
                        </ng-container>
                    </span>
                </ng-container>
            </h2>
        </div>

        <div class="col-lg-3 col-md-4 col-12 ps-md-0 sort-filter-group">
            <!-- MOBILE : Filtrer (popup) + Tri (chip) -->
            <button class="btn btn-primary sort-filter-btn visible-mobile"
                    (click)="trackingService.click('favorite_list_filter', favoritesList.id);filtersFullscreen = true">
                <i class="fa cfa cfa-filter"></i>
                <span>Filtrer</span>
                <span class="filter-badge" *ngIf="getActiveFilterCount() > 0">{{ getActiveFilterCount() }}</span>
            </button>
            <button class="btn btn-outline sort-chip visible-mobile" [matMenuTriggerFor]="sortMenu">
                <span class="sort-chip-label">Tri : {{ getSortLabel() }}</span>
                <i class="fa fa-chevron-down ms-2"></i>
            </button>

            <!-- DESKTOP : Tri select d'origine -->
            <mat-form-field class="no-label hide-mobile">
                <mat-label>Trier par :</mat-label>
                <mat-select [(ngModel)]="sort" disableOptionCentering
                            (ngModelChange)="onSortChange()"
                            placeholder="Trier par">
                    <mat-option *ngFor="let opt of sortOptions" [value]="opt.value">Trier par : {{ opt.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <!-- Barre de filtres desktop (chips) -->
        <div class="col-12 mb-3 hide-mobile">
            <div class="filter-bar">
                <!-- Titre -->
                <button class="filter-chip" [class.active]="searchForm.get('title').value"
                        [matMenuTriggerFor]="titleMenu" #titleTrigger="matMenuTrigger"
                        (click)="closeAllFilterMenus(titleTrigger)">
                    Titre
                    <ng-container *ngIf="searchForm.get('title').value">
                        : {{ searchForm.get('title').value }}
                    </ng-container>
                    <i class="fa fa-chevron-down ms-2"></i>
                </button>
                <mat-menu #titleMenu="matMenu" class="filter-menu" [hasBackdrop]="false" (opened)="onFilterMenuOpened(titleTrigger)"
                          (closed)="onFilterMenuClosed()">
                  <div class="filter-popup-panel" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <div class="filter-popup-title">Titre</div>
                    <div class="filter-popup">
                        <mat-form-field class="w-100" [formGroup]="searchForm">
                            <mat-label>Rechercher</mat-label>
                            <input matInput formControlName="title" placeholder="Rechercher par titre ou ville...">
                        </mat-form-field>
                    </div>
                    <div class="filter-popup-actions">
                        <button class="btn btn-outline btn-sm" type="button" (click)="clearQuickFilter('title')">Effacer</button>
                        <button class="btn btn-sm" type="button" (click)="applyQuickFilter(titleTrigger)">Appliquer</button>
                    </div>
                  </div>
                </mat-menu>

                <!-- Statut -->
                <button class="filter-chip" [class.active]="searchForm.get('status').value?.length"
                        [matMenuTriggerFor]="statusMenu" #statusTrigger="matMenuTrigger"
                        (click)="closeAllFilterMenus(statusTrigger)">
                    Statut
                    <ng-container *ngIf="searchForm.get('status').value?.length">
                        : {{ getStatusLabel() }}
                    </ng-container>
                    <i class="fa fa-chevron-down ms-2"></i>
                </button>
                <mat-menu #statusMenu="matMenu" class="filter-menu" [hasBackdrop]="false" (opened)="onFilterMenuOpened(statusTrigger)"
                          (closed)="onFilterMenuClosed()">
                  <div class="filter-popup-panel" (click)="$event.stopPropagation()">
                    <div class="filter-popup-title">Statut</div>
                    <div class="filter-popup filter-popup-check">
                        <div *ngFor="let s of status" class="filter-check-item">
                            <mat-checkbox [checked]="isStatusSelected(s)"
                                          (change)="toggleStatus(s)">
                                {{ commonService.getStatusLib(s) }}
                            </mat-checkbox>
                        </div>
                    </div>
                    <div class="filter-popup-actions">
                        <button class="btn btn-outline btn-sm" type="button" (click)="clearQuickFilter('status')">Effacer</button>
                        <button class="btn btn-sm" type="button" (click)="applyQuickFilter(statusTrigger)">Appliquer</button>
                    </div>
                  </div>
                </mat-menu>

                <!-- Ville -->
                <button class="filter-chip" [class.active]="selectedVilles.length > 0"
                        [matMenuTriggerFor]="villeMenu" #villeTrigger="matMenuTrigger"
                        (click)="closeAllFilterMenus(villeTrigger)">
                    Ville
                    <ng-container *ngIf="selectedVilles.length > 0">
                        : {{ selectedVilles.length }} sélectionnée(s)
                    </ng-container>
                    <i class="fa fa-chevron-down ms-2"></i>
                </button>
                <mat-menu #villeMenu="matMenu" class="filter-menu" [hasBackdrop]="false" (opened)="onFilterMenuOpened(villeTrigger)"
                          (closed)="onFilterMenuClosed()">
                  <div class="filter-popup-panel" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <div class="filter-popup-title">Ville</div>
                    <div class="filter-popup filter-popup-ville">
                        <mat-form-field class="w-100">
                            <mat-label>Rechercher une ville</mat-label>
                            <input matInput [value]="villeSearchText"
                                   (input)="searchVilles($event.target.value)"
                                   placeholder="Tapez le nom d'une ville...">
                        </mat-form-field>
                        <!-- Résultats d'autocomplete juste sous le champ, avant les villes sélectionnées -->
                        <div class="ville-results" *ngIf="villeResults$ | async as results" [hidden]="results.length === 0 && villeSearchText.length < 2">
                            <div *ngFor="let city of results" class="ville-result-item"
                                 (click)="selectVille(city)">
                                {{ city.name }}<ng-container *ngIf="city.type != 'global'"> ({{ city.zip_code }})</ng-container>
                            </div>
                            <div *ngIf="results.length === 0 && villeSearchText.length >= 2" class="ville-result-empty">
                                Aucun résultat
                            </div>
                        </div>
                        <div class="ville-chips" *ngIf="selectedVilles.length > 0">
                            <span class="ville-chip" *ngFor="let city of selectedVilles">
                                {{ city.name }}<ng-container *ngIf="city.type != 'global'"> ({{ city.zip_code }})</ng-container>
                                <i class="fa fa-times ms-1" (click)="removeVille(city)"></i>
                            </span>
                        </div>
                    </div>
                    <div class="filter-popup-actions">
                        <button class="btn btn-outline btn-sm" type="button" (click)="clearQuickFilter('ville')">Effacer</button>
                        <button class="btn btn-sm" type="button" (click)="applyQuickFilter(villeTrigger)">Appliquer</button>
                    </div>
                  </div>
                </mat-menu>

                <!-- Prix -->
                <button class="filter-chip" [class.active]="priceMin != null || priceMax != null"
                        [matMenuTriggerFor]="priceMenu" #priceTrigger="matMenuTrigger"
                        (click)="closeAllFilterMenus(priceTrigger)">
                    Prix
                    <ng-container *ngIf="priceMin != null || priceMax != null">
                        : {{ getPriceLabel() }}
                    </ng-container>
                    <i class="fa fa-chevron-down ms-2"></i>
                </button>
                <mat-menu #priceMenu="matMenu" class="filter-menu" [hasBackdrop]="false" (opened)="onFilterMenuOpened(priceTrigger)"
                          (closed)="onFilterMenuClosed()">
                  <div class="filter-popup-panel" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <div class="filter-popup-title">Prix</div>
                    <div class="filter-popup filter-popup-range">
                        <div class="filter-range-row">
                            <mat-form-field>
                                <mat-label>Minimum €</mat-label>
                                <input matInput type="number" [(ngModel)]="priceMin">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Maximum €</mat-label>
                                <input matInput type="number" [(ngModel)]="priceMax">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="filter-popup-actions">
                        <button class="btn btn-outline btn-sm" type="button" (click)="clearQuickFilter('price')">Effacer</button>
                        <button class="btn btn-sm" type="button" (click)="applyQuickFilter(priceTrigger)">Appliquer</button>
                    </div>
                  </div>
                </mat-menu>

                <!-- Rendement brut -->
                <button class="filter-chip" [class.active]="rendementMin != null || rendementMax != null"
                        [matMenuTriggerFor]="rendementMenu" #rendementTrigger="matMenuTrigger"
                        (click)="closeAllFilterMenus(rendementTrigger)">
                    Rendement brut
                    <ng-container *ngIf="rendementMin != null || rendementMax != null">
                        : {{ getRendementLabel() }}
                    </ng-container>
                    <i class="fa fa-chevron-down ms-2"></i>
                </button>
                <mat-menu #rendementMenu="matMenu" class="filter-menu" [hasBackdrop]="false" (opened)="onFilterMenuOpened(rendementTrigger)"
                          (closed)="onFilterMenuClosed()">
                  <div class="filter-popup-panel" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <div class="filter-popup-title">Rendement brut</div>
                    <div class="filter-popup filter-popup-range">
                        <div class="filter-range-row">
                            <mat-form-field>
                                <mat-label>Minimum %</mat-label>
                                <input matInput type="number" [(ngModel)]="rendementMin">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Maximum %</mat-label>
                                <input matInput type="number" [(ngModel)]="rendementMax">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="filter-popup-actions">
                        <button class="btn btn-outline btn-sm" type="button" (click)="clearQuickFilter('rendement')">Effacer</button>
                        <button class="btn btn-sm" type="button" (click)="applyQuickFilter(rendementTrigger)">Appliquer</button>
                    </div>
                  </div>
                </mat-menu>

                <!-- Compteur de filtres actifs + clear -->
                <button class="btn btn-outline-danger btn-sm" *ngIf="getActiveFilterCount() > 0"
                        (click)="clearFilters()">
                    <i class="fa fa-times me-1"></i>
                    Supprimer les filtres
                </button>
            </div>
        </div>

        <!-- Filtres (MOBILE) — panneau plein écran, même design que les filtres de la recherche -->
        <div class="filters-fullscreen visible-mobile" *ngIf="filtersFullscreen">
            <div class="container-fluid">
                <h2>Titre</h2>
                <mat-form-field class="w-100" [formGroup]="searchForm">
                    <mat-label>Rechercher</mat-label>
                    <input matInput formControlName="title" placeholder="Rechercher par titre...">
                </mat-form-field>

                <h2>Statut</h2>
                <div class="type-menu-check">
                    <a class="type-option" *ngFor="let s of status"
                       [class.active]="isStatusSelected(s)" (click)="toggleStatus(s)">
                        <span class="status-dot status-dot-{{s}}"></span>
                        <span class="type-option-label">{{ commonService.getStatusLib(s) }}</span>
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </div>

                <h2>Ville</h2>
                <mat-form-field class="w-100">
                    <mat-label>Rechercher une ville</mat-label>
                    <input matInput [value]="villeSearchText"
                           (input)="searchVilles($event.target.value)"
                           placeholder="Tapez le nom d'une ville...">
                </mat-form-field>
                <!-- Autocomplete juste sous le champ de recherche (même design que desktop) -->
                <div class="ville-results" *ngIf="villeResults$ | async as results" [hidden]="results.length === 0 && villeSearchText.length < 2">
                    <div *ngFor="let city of results" class="ville-result-item" (click)="selectVille(city)">
                        {{ city.name }}<ng-container *ngIf="city.type != 'global'"> ({{ city.zip_code }})</ng-container>
                    </div>
                    <div *ngIf="results.length === 0 && villeSearchText.length >= 2" class="ville-result-empty">
                        Aucun résultat
                    </div>
                </div>
                <!-- Villes sélectionnées : mêmes chips que les filtres actifs -->
                <div class="active-filters ville-chips" *ngIf="selectedVilles.length > 0">
                    <span class="active-chip" *ngFor="let city of selectedVilles">
                        {{ city.name }}<ng-container *ngIf="city.type != 'global'"> ({{ city.zip_code }})</ng-container>
                        <i class="fa fa-times" (click)="removeVille(city)"></i>
                    </span>
                </div>

                <h2>Prix</h2>
                <div class="row">
                    <div class="col-6 pe-0">
                        <mat-form-field>
                            <mat-label>Min</mat-label>
                            <input matInput type="number" [(ngModel)]="priceMin">
                            <span matSuffix> €</span>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Max</mat-label>
                            <input matInput type="number" [(ngModel)]="priceMax">
                            <span matSuffix> €</span>
                        </mat-form-field>
                    </div>
                </div>

                <h2>Rendement brut</h2>
                <div class="row">
                    <div class="col-6 pe-0">
                        <mat-form-field>
                            <mat-label>Min</mat-label>
                            <input matInput type="number" [(ngModel)]="rendementMin">
                            <span matSuffix> %</span>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Max</mat-label>
                            <input matInput type="number" [(ngModel)]="rendementMax">
                            <span matSuffix> %</span>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="container-fluid filters-actions">
                <div class="d-flex justify-content-between gap-3">
                    <button class="btn btn-lg btn-outline" type="button" (click)="clearFilters()">
                        <i class="fa fa-refresh"></i> Tout effacer
                    </button>
                    <button class="btn btn-lg" type="button"
                            (click)="filtersFullscreen = false; page = 1; loadFavorites()">
                        <i class="fa fa-search"></i> Rechercher
                    </button>
                </div>
            </div>
        </div>

        <!-- Popup Tri -->
        <mat-menu #sortMenu="matMenu" class="mobile-sheet" backdropClass="mobile-sheet-backdrop">
            <button mat-menu-item *ngFor="let opt of sortOptions" (click)="sort = opt.value; onSortChange()">
                <i class="fa fa-check me-2" [style.visibility]="sort === opt.value ? 'visible' : 'hidden'"></i>
                <span>{{ opt.label }}</span>
            </button>
        </mat-menu>

        <!-- Choix des indicateurs : contenu partagé entre la carte inline (desktop) et la popup (mobile) -->
        <ng-template #indicContentTpl>
                <mat-button-toggle-group class="container-fluid" [multiple]="true" #group="matButtonToggleGroup"
                                         [value]="displayedColumns" (change)="onColChange(group.value)">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-4">
                                <details class="indicateur-section" [open]="isIndicOpen('general')">
                                <summary class="fs-4 mb-2" (click)="toggleIndic('general', $event)">Informations générales</summary>

                                <mat-button-toggle value="ad.square_land">
                                    Surface du terrain
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="lots.length">
                                    Nombre de lots
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="fav.created_at">
                                    Date d'ajout
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad.owner_name">
                                    Nom du contact
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="works_total">
                                    Montant de travaux
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="furniture_price">
                                    Montant des meubles
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="dpe">
                                    DPE
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ges">
                                    GES
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="comment">
                                    Notes
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="liens">
                                    Liens de l'annonce
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>
                                </details>
                            </div>
                            <div class="col-md-4">
                                <details class="indicateur-section" [open]="isIndicOpen('ville')">
                                <summary class="fs-4 mb-2" (click)="toggleIndic('ville', $event)">Informations sur la ville</summary>

                                <mat-button-toggle value="ad_city.price_diff">
                                    Différence de prix
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.advice_price">
                                    Prix au m²
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.demographie_annuelle">
                                    Population
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="favorite.ad_city.renta">
                                    Rentabilité moyenne
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.mv">
                                    Niveau de vie moy par hab
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tv">
                                    Taux de logements vacants
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.te">
                                    Taux d'étudiants
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tc">
                                    Taux de chômage
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tl">
                                    Taux de locataires
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.logement.anc_loc_ann">
                                    Ancienneté des locataires
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>
                                </details>
                            </div>
                            <div class="col-md-4">
                                <details class="indicateur-section" [open]="isIndicOpen('financieres')">
                                <summary class="fs-4 mb-2" (click)="toggleIndic('financieres', $event)">Informations financières</summary>
                                <mat-button-toggle value="efficiency_brut">
                                    Rendement brut
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="efficiency_net">
                                    Rendement net
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="cash_flow">
                                    Cash-flow
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_rent">
                                    Total des loyers
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="charge">
                                    Total des charges
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_property_tax">
                                    Taxe foncière
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_copro">
                                    Charges de copropriété
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="monthly">
                                    Mensualité
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="building_insurance">
                                    Assurance PNO
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="accouting_fees">
                                    Frais de comptabilité
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>
                                </details>
                            </div>
                        </div>
                    </div>
                </mat-button-toggle-group>
        </ng-template>

        <!-- Desktop : carte inline (design d'origine) -->
        <div class="col-12 hide-mobile">
            <div class="card searchResult selectColumns mb-4" [hidden]="!columsSelection"
                 [stepContent]="listColumnStepContent"
                 [joyrideStep]="'listColumnStep'"
                 (prev)="displayColumsSelection();">
                <h3>
                    Personnalisation des indicateurs
                    <i (click)="trackingService.click('favorite_list_indicateur_close', favoritesList.id);displayColumsSelection()"
                       class="fa fa-close float-right cursor-pointer"></i>
                </h3>
                <p>Vous pouvez choisir les indicateurs qui seront affichés lors de votre recherche. </p>
                <ng-container *ngTemplateOutlet="indicContentTpl"></ng-container>
                <button class="btn btn-primary center w-100 mt-3"
                        (click)="trackingService.click('favorite_list_indicateur_valider', favoritesList.id);displayColumsSelection()">
                    Valider
                </button>
            </div>
        </div>

        <!-- Mobile : popup à la norme du site -->
        <ng-template #indicDialogTpl>
            <div class="fs-2 with-close" mat-dialog-title>
                Personnalisation des indicateurs
                <i class="fa fa-close" (click)="indicDialogRef.close()" aria-hidden="true"></i>
            </div>
            <div mat-dialog-content class="selectColumns">
                <ng-container *ngTemplateOutlet="indicContentTpl"></ng-container>
            </div>
            <div mat-dialog-actions>
                <button class="btn btn-primary center"
                        (click)="trackingService.click('favorite_list_indicateur_valider', favoritesList.id);indicDialogRef.close()">
                    Valider
                </button>
            </div>
        </ng-template>

        <!-- Onglets Liste / Carte : sous les filtres, juste au-dessus du contenu -->
        <div class="col-12">
            <div class="tabs tabs_full fav-view-tabs">
                <a class="tab" [class.active]="view === 'list'" (click)="view = 'list'">Liste</a>
                <a class="tab" [class.active]="view === 'map'" (click)="view = 'map'">Carte</a>
            </div>
        </div>

        <!-- Vue Carte (embarquée) : mêmes filtres que la liste (envoyés au backend), conservés au switch -->
        <div class="col-12" *ngIf="view === 'map'">
            <app-favorites-map [embedded]="true" [filters]="mapFilters" [currentListId]="currentList"></app-favorites-map>
        </div>

        <!-- Vue Liste des favoris -->
        <ng-container *ngIf="view === 'list'">
        <ng-container *ngFor="let favorite of favorites; index as i;">
            <div class="col-12 mb-4" id="fav_{{favorite.id}}">
                <div class="card searchResult">
                    <div class="card-body card-{{ favorite.ad.ai_id }}">
                        <div class="container-fluid">
                            <div class="mainRow row">
                                <div class="titleInfo">
                                    <app-status [favorite]="favorite" class="me-md-5 float-left float-md-end list"></app-status>
                                    <span class="published-picto ms-2 ms-md-0 me-md-2 float-left float-md-end" *ngIf="adService.isPublished(favorite)">
                                        <i class="cfa cfa-star"></i>Publié sur LyBox
                                    </span>
                                    <span class="published-picto published-picto-off ms-2 ms-md-0 me-md-2 float-left float-md-end" *ngIf="adService.isUnpublished(favorite)">
                                        <i class="cfa cfa-warning"></i>Non publié
                                    </span>
                                    <b class="fs-3 w-100">{{ favorite.title }}</b>
                                    <div class="col-12 iconeInfo">
                                        <!-- Desktop : dropdown Bootstrap d'origine -->
                                        <div class="ms-2 dropdown dropstart hide-mobile">
                                            <button class="icone icone-flat" id="dropdownEdit-{{i}}"
                                                    data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false"
                                                    (click)="trackingService.click('favorite_list_option_favorite', favorite.id);"
                                                    [stepContent]="favListLastInfoStepContent"
                                                    [joyrideStep]="'favListLastInfoStep' + i">
                                                <i class="fa fa-ellipsis-v"></i>
                                            </button>
                                            <div id="editDropdown-{{i}}" class="dropdown-menu dropdown-menu-right"
                                                 aria-labelledby="dropdownEdit"
                                                 aria-haspopup="true" aria-expanded="false">
                                                <ul class="pictoList">
                                                    <li>
                                                        <a (click)="trackingService.click('favorite_list_favorite_move', favorite.id);moveFavorite(favorite)">
                                                            <i class="fa fa-arrows-h"></i>
                                                            Déplacer ce favori
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a (click)="trackingService.click('favorite_list_favorite_notes', favorite.id);noteFavorite(favorite)">
                                                            <i class="fa fa-sticky-note-o"></i>
                                                            Modifier mes notes
                                                        </a>
                                                    </li>
                                                    <li *ngIf="authenticationService.canPublishFavorite">
                                                        <a (click)="trackingService.click('favorite_list_favorite_publish', favorite.id);publishFavorite(favorite)">
                                                            <i class="fa fa-bullhorn"></i>
                                                            {{ adService.isPublished(favorite) ? 'Modifier ma publication' : 'Publier sur LyBox' }}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a (click)="trackingService.click('favorite_list_favorite_compare', favorite.id);compareAdd(favorite)">
                                                            <i class="fa fa-table"></i>
                                                            Ajouter au comparateur
                                                        </a>
                                                    </li>
                                                    <li class="delete">
                                                        <a (click)="trackingService.click('favorite_list_favorite_delete', favorite.id);deleteFavorite(favorite)">
                                                            <i class="fa cfa cfa-trash"></i>
                                                            Supprimer
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <!-- Mobile : popup centrée + fond assombri, comme les autres menus -->
                                        <div class="ms-2 dropdown dropstart visible-mobile">
                                            <button class="icone icone-flat"
                                                    (click)="trackingService.click('favorite_list_option_favorite', favorite.id);"
                                                    [matMenuTriggerFor]="favMenu">
                                                <i class="fa fa-ellipsis-v"></i>
                                            </button>
                                            <mat-menu #favMenu="matMenu" class="mobile-sheet edit-sheet-menu" backdropClass="mobile-sheet-backdrop">
                                                <button mat-menu-item
                                                        (click)="trackingService.click('favorite_list_favorite_ai_analysis', favorite.id);openAIAnalysis(favorite)">
                                                    <i class="fa fa-magic"></i>
                                                    <span>Analyse IA</span>
                                                </button>
                                                <button mat-menu-item
                                                        (click)="trackingService.click('favorite_list_favorite_move', favorite.id);moveFavorite(favorite)">
                                                    <i class="fa fa-arrows-h"></i>
                                                    <span>Déplacer ce favori</span>
                                                </button>
                                                <button mat-menu-item
                                                        (click)="trackingService.click('favorite_list_favorite_notes', favorite.id);noteFavorite(favorite)">
                                                    <i class="fa fa-sticky-note-o"></i>
                                                    <span>Modifier mes notes</span>
                                                </button>
                                                <button mat-menu-item *ngIf="authenticationService.canPublishFavorite"
                                                        (click)="trackingService.click('favorite_list_favorite_publish', favorite.id);publishFavorite(favorite)">
                                                    <i class="fa fa-bullhorn"></i>
                                                    <span>{{ adService.isPublished(favorite) ? 'Modifier ma publication' : 'Publier sur LyBox' }}</span>
                                                </button>
                                                <button mat-menu-item
                                                        (click)="trackingService.click('favorite_list_favorite_compare', favorite.id);compareAdd(favorite)">
                                                    <i class="fa fa-table"></i>
                                                    <span>Ajouter au comparateur</span>
                                                </button>
                                                <button mat-menu-item class="text-danger"
                                                        (click)="trackingService.click('favorite_list_favorite_delete', favorite.id);deleteFavorite(favorite)">
                                                    <i class="fa cfa cfa-trash"></i>
                                                    <span>Supprimer</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                    </div>
                                </div>
                                <div class="wrapImg me-2 mb-lg-0 mb-2">
                                    <app-status [favorite]="favorite" class="status-mobile-overlay"></app-status>
                                    <img *ngIf="favorite.pictures.length == 0" src="assets/no-photo.png" alt=""/>
                                    <div *ngIf="favorite.pictures.length > 0" id="picturesCarousel{{favorite.ad.ai_id}}"
                                         class="carousel slide" data-ride="carousel">
                                        <div class="carousel-inner">
                                            <div *ngFor="let picture of favorite.pictures; index as ig;"
                                                 [ngClass]="{'carousel-item': true, 'active': ig == 0}"
                                                 [ngStyle]="{ 'background-image': 'url(' + picture + ')'}">
                                                <img *ngIf="picture" style="display: none;" src="{{ picture }}"
                                                     (error)="imageService.changeImg($event)">
                                            </div>
                                        </div>
                                        <button *ngIf="favorite.pictures.length > 1" class="carousel-control-prev"
                                                type="button"
                                                [attr.data-bs-target]="'#picturesCarousel' + favorite.ad.ai_id"
                                                data-bs-slide="prev">
                                            <i class="fa fa-chevron-left"
                                               (click)="trackingService.click('favorite_list_image_prev', favorite.id);"></i>
                                            <span class="visually-hidden">Previous</span>
                                        </button>
                                        <button *ngIf="favorite.pictures.length > 1" class="carousel-control-next"
                                                type="button"
                                                [attr.data-bs-target]="'#picturesCarousel' + favorite.ad.ai_id"
                                                data-bs-slide="next">
                                            <i class="fa fa-chevron-right"
                                               (click)="trackingService.click('favorite_list_image_next', favorite.id);"></i>
                                            <span class="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="mainInfo me-lg-2 mb-lg-0 mb-2"
                                     [stepContent]="favListInfoStepContent"
                                     [joyrideStep]="'favListInfoStep' + i">
                                    <b class="price text-primary fs-2 price">
                                        {{ favorite.price | number: '1.0-0' }} €
                                    </b>
                                    <b class="squarePrice text-secondary d-block" *ngIf="favorite.square > 0">
                                        {{ (favorite.price / favorite.square) | number: '1.0-0' }} €/m²
                                    </b>
                                    <b class="estateType mt-2 fs-4 d-block"
                                       [class.has-details]="favorite.square > 0 || favorite.ad.rooms > 0">
                                        {{ favorite.ad.real_estate_type }}
                                        <ng-container *ngIf="!favorite.ad.real_estate_type"><br/></ng-container>
                                    </b>

                                    <b class="squareRoom text-secondary d-block">
                                        <ng-container *ngIf="favorite.square > 0">
                                            {{ favorite.square | number: '1.0-0' }} m²
                                        </ng-container>
                                        <ng-container *ngIf="favorite.square > 0 && favorite.ad.rooms > 0">
                                            -
                                        </ng-container>
                                        <ng-container *ngIf="favorite.ad.rooms > 0">
                                            {{ favorite.ad.rooms }} pièce{{ favorite.ad.rooms > 1 ? 's' : '' }}
                                        </ng-container>
                                    </b>

                                    <span class="fpb text-secondary d-block mt-2 fs-small">
                                    <i class="fa cfa cfa-calendar"
                                       *ngIf="favorite.ad.first_publication_date"></i> {{ favorite.ad.first_publication_date }}
                                        <ng-container *ngIf="!favorite.ad.first_publication_date"><br/></ng-container>
                                </span>

                                    <p>
                                        <a class="mt-2 btn btn-primary btn-sm d-block"
                                           (click)="trackingService.click('favorite_list_open_favorite', favorite.id);"
                                           [routerLink]="['/app/favorites', isAllList ? favorite.favorite_list?.id : favoritesList.id, favorite.id]"
                                           [queryParams]="{returnPage: page, returnList: currentList}">
                                            Ouvrir
                                        </a>
                                    </p>
                                </div>
                                <div class="kpiInfo pe-3 ps-3 col-xxl-6 col-xl-6 col-lg-5"
                                     [stepContent]="favListKPIStepContent"
                                     [joyrideStep]="'favListKPIStep' + i">
                                    <div class="row">
                                        <div class="col-12 iconeInfo">
                                            <div class="icone"
                                                 *ngIf="favorite.comment != ''  && favorite.id != ''">
                                                <i matTooltip="{{ favorite.comment }}"
                                                   (click)="trackingService.click('favorite_list_favorite_notes_ico', favorite.id);noteFavorite(favorite)"
                                                   class="fa fa-sticky-note-o text-grey ad_category" type="button"></i>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.price_change">
                                                <p class="svg baisse-prix" matTooltip="Baisse de prix"
                                                   #tipPrix="matTooltip" (click)="isMobile && tipPrix.show()"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.work">
                                                <p matTooltip="Travaux à prévoir" class="svg work"
                                                   #tipWork="matTooltip" (click)="isMobile && tipWork.show()"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.rent">
                                                <p class="svg rent-result" matTooltip="Locataire en place"
                                                   #tipRent="matTooltip" (click)="isMobile && tipRent.show()"></p>
                                            </div>
                                            <div class="icone"
                                                 *ngIf="favorite.ad.adress != '' && favorite.ad.adress != '-'">
                                                <p class="svg adress" matTooltip="Adresse du bien enregistrée"
                                                   #tipAdress="matTooltip" (click)="isMobile && tipAdress.show()"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.bad_location">
                                                <p class="svg bad_city"
                                                   matTooltip="La ville renseignée semble incorrecte"
                                                   #tipBadCity="matTooltip" (click)="isMobile && tipBadCity.show()"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.category == 'Viager'">
                                                <p class="svg viager" matTooltip="Le bien est vendu en viager."
                                                   #tipViager="matTooltip" (click)="isMobile && tipViager.show()"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.category == 'Enchere'">
                                                <p class="svg enchere" matTooltip="Le bien est vendu aux enchères."
                                                   #tipEnchere="matTooltip" (click)="isMobile && tipEnchere.show()"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.has_local_commercial">
                                                <p class="svg commerce"
                                                   matTooltip="Le lot comprend un local commercial"
                                                   #tipCommerce="matTooltip" (click)="isMobile && tipCommerce.show()"></p>
                                            </div>
                                            <div class="icone" *ngIf="!adService.isSquareValid(favorite)">
                                                <p class="svg bad_square"
                                                   matTooltip="La surface du bien semble incorrecte"
                                                   #tipBadSquare="matTooltip" (click)="isMobile && tipBadSquare.show()"></p>
                                            </div>
                                        </div>
                                        <div class="col-12 fs-small city ps-0 ps-md-2">
                                            <i class="cfa cfa-pin"></i>
                                            <span class="text-primary me-3" *ngIf="favorite.ad_city.name != ''"
                                                  matTooltip="{{ favorite.ad_city.name }} ({{ favorite.ad_city.zip_code }})"
                                                  [matTooltipDisabled]="!isMobile"
                                                  #cityTip="matTooltip" (click)="showCityTip(cityTip, $event)"
                                                  (mouseenter)="setCityCursor($event)">
                                                {{ favorite.ad_city.name }}
                                                ({{ favorite.ad_city.zip_code }})
                                            </span>
                                            <span class="hide-mobile">
                                                <ng-container *ngIf="favorite.ad.urls && favorite.ad.urls.length > 0">
                                                    <i class="fa fa-flag me-2"></i>
                                                    {{ adService.getProviderLib(favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider) }}
                                                </ng-container>
                                            </span>
                                        </div>
                                        <div class="col-12 dataInfo mt-md-4">
                                            <div class="row">
                                                <ng-container *ngFor="let dc of displayedColumns; index as idc;">
                                                    <div class="kpi-value kpi-blank"
                                                         *ngIf="idc == 4 && (displayedColumns.length == 7 || displayedColumns.length == 8)"></div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.price_diff'">
                                                        <label>Différence
                                                            <i class="fa fa-question-circle"
                                                               matTooltip="Comparaison avec {{ cityService.getFullLib(favorite.advice_price_real, favorite.ad_city, favorite.iris) }}"></i>
                                                        </label>
                                                        <p *ngIf="favorite.advice_price > 0 && favorite.square > 0"
                                                           [ngClass]="{'value': true, 'text-green' : favorite.price / favorite.square < favorite.advice_price, 'text-red' : favorite.price / favorite.square > favorite.advice_price}">
                                                            {{ ((favorite.price / favorite.square) / favorite.advice_price * 100) - 100 | number:'1.0-0' }}
                                                            %
                                                        </p>
                                                        <p *ngIf="favorite.advice_price == 0 || !(favorite.square > 0)" class="value-empty">-</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.demographie_annuelle'">
                                                        <label>Nb. d'habitants</label>
                                                        <p *ngIf="favorite.ad_city.demographie_annuelle && favorite.ad_city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] > 0; else noValueTpl"
                                                           [ngClass]="{'value': true, 'text-green' : favorite.ad_city.demographie_annuelle.Cr == 1, 'text-red' : favorite.ad_city.demographie_annuelle.Cr == -1}">
                                                            {{ favorite.ad_city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] | number: '1.0-0' }}
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == 1"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie en hausse"
                                                               class="fa fa-arrow-up"></i>
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == 0"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie stable"
                                                               class="fa fa-arrow-right"></i>
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == -1"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie en baisse"
                                                               class="fa fa-arrow-down"></i>
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.mv'">
                                                        <label>Niv. de vie/hab</label>
                                                        <p class="value" *ngIf="favorite.ad_city.carac_commune.MED_NV > 0; else noValueTpl">
                                                            {{ favorite.ad_city.carac_commune.MED_NV | number: '1.0-0' }} €
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'favorite.ad_city.renta'">
                                                        <label>Rend. ville
                                                            <i class="fa fa-question-circle"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Rendement moyen dans la ville ({{ (favorite.ad_city.renta['r_type'] == 'M' ?  'pour les maisons uniquement' : favorite.ad_city.renta['r_type'] == 'A' ? 'pour les appartements uniquement' : 'tous types de  biens confondus') }} et sans prise en compte des travaux)."></i>
                                                        </label>
                                                        <p class="value" *ngIf="favorite.ad_city.renta && favorite.ad_city.renta['r'] > 0; else noValueTpl">
                                                            {{ favorite.ad_city.renta["r"] * 100| number: '1.0-1' }} %
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.te'">
                                                        <label>Étudiants</label>
                                                        <p *ngIf="favorite.ad_city.carac_commune.T_etud != null; else noValueTpl"
                                                           [ngClass]="{'value': true, 'text-green' : favorite.ad_city.carac_commune.T_etud >= 0.12 , 'text-red' : favorite.ad_city.carac_commune.T_etud <= 0.08}">
                                                            {{ favorite.ad_city.carac_commune.T_etud * 100 | number: '1.1-1' }} %
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.advice_price'">
                                                        <label>Prix au m²
                                                            <i class="fa fa-question-circle"
                                                               matTooltip="Moyenne pour {{ cityService.getFullLib(favorite.advice_price_real, favorite.ad_city, favorite.iris) }}"></i>
                                                        </label>
                                                        <p class="value" *ngIf="favorite.advice_price > 0; else noValueTpl">
                                                            {{ favorite.advice_price | number:'1.0-0' }} €/m²
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'amount_rent'">
                                                        <label>Loyer total</label>
                                                        <p class="value" *ngIf="favorite.amount_rent > 0; else noValueTpl">
                                                            {{ favorite.amount_rent | number: '1.0-0' }} €/mois
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tc'">
                                                        <label>Chômage</label>
                                                        <p *ngIf="favorite.ad_city.carac_commune.T_chom != null; else noValueTpl"
                                                           [ngClass]="{'value': true, 'text-green' : favorite.ad_city.carac_commune.T_chom < 0.075 , 'text-red' : favorite.ad_city.carac_commune.T_chom >= 0.13}">
                                                            {{ favorite.ad_city.carac_commune.T_chom * 100 | number: '1.1-1' }} %
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad.square_land'">
                                                        <label>Surface terrain</label>
                                                        <p class="value" *ngIf="favorite.ad.square_land > 0; else noValueTpl">{{ favorite.ad.square_land }} m²</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'lots.length'">
                                                        <label>Nombre de lots</label>
                                                        <p class="value" *ngIf="favorite.nb_lots > 0; else noValueTpl">{{ favorite.nb_lots }}</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'fav.created_at'">
                                                        <label>Date de création</label>
                                                        <p class="value text">{{ favorite.created_at | date:'short' }}</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad.owner_name'">
                                                        <label>Contact</label>
                                                        <p class="value text" *ngIf="favorite.ad.owner_name; else noValueTpl">{{ favorite.ad.owner_name | slice:0:15 }}</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'works_total'">
                                                        <label>Travaux</label>
                                                        <p class="value" *ngIf="favorite.works_total + favorite.other_fees_work > 0; else noValueTpl">{{ favorite.works_total + favorite.other_fees_work | number: '1.0-0' }} €</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'furniture_price'">
                                                        <label>Meubles</label>
                                                        <p class="value" *ngIf="favorite.furniture_price > 0; else noValueTpl">{{ favorite.furniture_price | number: '1.0-0' }} €</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'dpe'">
                                                        <label>DPE</label>
                                                        <app-dpe [favorite]="favorite"></app-dpe>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ges'">
                                                        <label>GES</label>
                                                        <app-ges [favorite]="favorite"></app-ges>
                                                    </div>
                                                    <div class="kpi-value double_row" *ngIf="dc == 'comment'">
                                                        <label>Notes</label>
                                                        <p class="value text">{{ favorite.comment | slice:0:100 }}</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'liens'">
                                                        <label>Liens</label>
                                                        <div class="value value-link" *ngIf="favorite.ad.urls && favorite.ad.urls.length > 0; else noValueTpl">
                                                            <a [ngClass]="'btn btn-'+favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider+' btn-sm'"
                                                               *ngIf="favorite.ad.urls.length > 0 && adService.getProviderLib(favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider) != 'Site partenaire'"
                                                               href="{{ favorite.ad.urls[adService.findSmallLink(favorite.ad)].url }}"
                                                               target="_blank">
                                                                {{ adService.getProviderLib(favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider) }}
                                                            </a>
                                                            <a [ngClass]="'btn btn-'+favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider+' btn-sm'"
                                                               *ngIf="favorite.ad.urls.length > 0 && adService.getProviderLib(favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider) == 'Site partenaire'">
                                                                Site partenaire
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tv'">
                                                        <label>Logements vacants</label>
                                                        <p class="value" *ngIf="favorite.ad_city.logement.T_LV != null; else noValueTpl">{{ favorite.ad_city.logement.T_LV * 100 | number: '1.1-1' }} %</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tl'">
                                                        <label>Taux de locataires</label>
                                                        <p class="value" *ngIf="favorite.ad_city.carac_commune.T_LOC != null; else noValueTpl">{{ favorite.ad_city.carac_commune.T_LOC * 100 | number: '1.1-1' }} %</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.logement.anc_loc_ann'">
                                                        <label>Ancienneté des locataires</label>
                                                        <p class="value" *ngIf="favorite.ad_city.logement.anc_loc_ann > 0; else noValueTpl">{{ favorite.ad_city.logement.anc_loc_ann | number: '1.1-1' }} ans</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'efficiency_brut'">
                                                        <label>Rendement brut</label>
                                                        <p class="value" *ngIf="favorite.efficiency_brut != 0; else noValueTpl">{{ favorite.efficiency_brut | number: '1.1-1' }} %</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'efficiency_net'">
                                                        <label>Rendement net</label>
                                                        <p class="value" *ngIf="favorite.efficiency_net != 0; else noValueTpl">{{ favorite.efficiency_net | number: '1.1-1' }} %</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'cash_flow'">
                                                        <label>Cash flow</label>
                                                        <p *ngIf="favorite.amount_rent != 0; else noValueTpl"
                                                           [ngClass]="{'value': true, 'text-green' : favorite.cash_flow >= 0, 'text-red' : favorite.cash_flow < 0}">
                                                            {{ favorite.cash_flow | number: '1.0-0' }} €
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'charge'">
                                                        <label>Charges</label>
                                                        <p class="value" *ngIf="favorite.charge > 0; else noValueTpl">{{ favorite.charge | number: '1.0-0' }} €</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'amount_property_tax'">
                                                        <label>Taxe foncière</label>
                                                        <p class="value" *ngIf="favorite.amount_property_tax > 0; else noValueTpl">{{ favorite.amount_property_tax | number: '1.0-0' }} €</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'amount_copro'">
                                                        <label>Charges de copro</label>
                                                        <p class="value" *ngIf="favorite.amount_copro > 0; else noValueTpl">{{ favorite.amount_copro | number: '1.0-0' }} €</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'monthly'">
                                                        <label>Mensualité</label>
                                                        <p class="value" *ngIf="favorite.monthly > 0; else noValueTpl">{{ favorite.monthly | number: '1.0-0' }} €</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'building_insurance'">
                                                        <label>PNO</label>
                                                        <p class="value" *ngIf="favorite.building_insurance > 0; else noValueTpl">{{ favorite.building_insurance | number: '1.0-0' }} €</p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'accouting_fees'">
                                                        <label>Compta</label>
                                                        <p class="value" *ngIf="favorite.accouting_fees > 0; else noValueTpl">{{ favorite.accouting_fees | number: '1.0-0' }} €</p>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="lastInfo">
                                    <div class="wrap p-3">
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block">Cash flow / mois</label>
                                            <b class="text-primary fs-4">
                                                <ng-container *ngIf="favorite.amount_rent != 0">{{ favorite.cash_flow | number: '1.0-0' }} €</ng-container><span class="value-empty" *ngIf="favorite.amount_rent == 0">-</span>
                                            </b>
                                        </div>
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block">Rendement brut</label>
                                            <b class="text-primary fs-4">
                                                <ng-container *ngIf="favorite.efficiency_brut != 0">{{ favorite.efficiency_brut | number: '1.1-1' }} %</ng-container><span class="value-empty" *ngIf="favorite.efficiency_brut == 0">-</span>
                                            </b>
                                        </div>
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block">Rendement net</label>
                                            <b class="text-primary fs-4">
                                            <ng-container *ngIf="favorite.efficiency_net != 0">{{ favorite.efficiency_net | number: '1.1-1' }} %</ng-container><span class="value-empty" *ngIf="favorite.efficiency_net == 0">-</span>
                                            </b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="col-12" *ngIf="pages.length > 1 && !loading">
            <ul class="pagination mb-4">
                <li *ngIf="page > 1"><a class="prev" (click)="goToPage(page - 1)">&lt;</a></li>
                <li *ngFor="let p of pages"><a [ngClass]="{'current' : p == page}" (click)="goToPage(p)">{{ p }}</a></li>
                <li *ngIf="page < pages[pages.length - 1]"><a class="next" (click)="goToPage(page + 1)">&gt;</a></li>
            </ul>
        </div>

        <div class="col-12 mb-4" [hidden]="favorites.length > 0 || loading == true">
            <div class="card searchResult">
                <div>
                    <b class="title text-center d-block mt-3 fs-3 mb-3">
                        Aucun favori dans cette liste<br/>
                    </b>
                    <p class="text-center">
                        Vous pouvez enregistrer des annonces en favoris depuis notre moteur de recherche ou importer
                        votre projet (biens off market par exemple).
                    </p>
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-3 mt-4 mb-2 mb-lg-3">
                            <a class="btn btn-outline d-block"
                               (click)="trackingService.click('favorite_list_empty_import', favoritesList.id);"
                               [routerLink]="['/app/tools/new']">
                                Importer mon projet
                            </a>
                        </div>
                        <div class="col-12 col-lg-3 mb-3 mt-lg-4">
                            <a class="btn d-block"
                               (click)="trackingService.click('favorite_list_empty_search', favoritesList.id);"
                               [routerLink]="['/app/search']">
                                Lancer une recherche
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12" [hidden]="!loading">
            <div class="card card-loading">
                <div class="card-body">
                    <mat-spinner color="second"></mat-spinner>
                </div>
            </div>
        </div>
        </ng-container>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="introStepContent"
             joyrideStep="introStep"
             stepPosition="center">
</joyrideStep>
<ng-template #introStepContent>
    <div class="user_onboarding_content">
        <h2>Bienvenue dans vos annonces favorites</h2>
        <p>
            Dans ce menu, vous allez pouvoir <b>organiser toutes vos annonces enregistrées</b>.<br/>
            <br/>
            Les informations clés sont visibles pour vous souvenir rapidement pourquoi le projet était intéressant<br/>
            <br/>
            Ces informations sont séparées en <b>3 parties</b>, faisons le tour ensemble !
        </p>
    </div>
</ng-template>

<ng-template #favListInfoStepContent>
    <div class="user_onboarding_content">
        <h2>1ère partie : La base</h2>
        <p>
            Vous retrouverez ici les <b>informations de base</b> de l'annonce et le lien pour ouvrir le détail de votre
            analyse.
        </p>
    </div>
</ng-template>

<ng-template #favListKPIStepContent>
    <div class="user_onboarding_content">
        <h2>2ème partie : Les données avancées</h2>
        <p>
            Sur chaque annonce, vous retrouverez les <b>informations importantes</b><br/>
            <br/>
            Vous pouvez cliquer sur le menu déroulant pour définir le "statut" de ce favori : "Analyse
            en cours", "A contacter", "A visiter" …<br/>
            <br/>
            Idéal pour suivre facilement l'avancement de chaque projet !
            <b>Astuce</b> : Vous pouvez choisir les indicateurs à afficher ! On voit ça juste après 😉
            <br/>
        </p>
    </div>
</ng-template>

<ng-template #favListLastInfoStepContent>
    <div class="user_onboarding_content">
        <h2>3ème partie : Gestion de votre favori</h2>
        <p>
            Pour retourner dans la simulation, supprimer votre favori, ou bien le comparer à d'autres favoris, c'est
            ici.
        </p>
    </div>
</ng-template>

<ng-template #listDropdownStepContent>
    <div class="user_onboarding_content">
        <h2>Les options avancées</h2>
        <p>
            En cliquant ici, vous pourrez <b>choisir les indicateurs</b> à afficher sur chaque annonce.<br/>
            <br/>
            Et oui, c'est <b>maintenant</b> !
        </p>
    </div>
</ng-template>

<ng-template #listColumnStepContent>
    <div class="user_onboarding_content">
        <h2>Les options avancées</h2>
        <p>
            Vous avez accès à différents indicateurs sur l'annonce, la ville, ou bien les <b>chiffres financiers</b> du
            projet.<br/>
            <br/>
            Cliquez simplement sur les cases qui vous intéressent pour ajouter/supprimer des indicateurs, puis cliquez
            sur la croix en haut à droite.<br/>
            <br/>
            <b>Facile, non ?</b>
        </p>
    </div>
</ng-template>

<ng-template #compareStepContent>
    <div class="user_onboarding_content">
        <h2>Bienvenue dans la comparaison de projets</h2>
        <p>
            Vous avez plusieurs annonces qui vous intéressent mais vous ne savez pas laquelle est la plus intéressante ?<br/>
            <br/>
            <b>Faisons ensemble une comparaison de ces annonces !</b><br/>
            <br/>
            <b>Astuce</b> : Vous pouvez aussi comparer plusieurs scénarios sur un même projet (avec ou sans travaux,
            avec division ou non …)<br/>
            <br/>
            Pour cela, rendez-vous dans votre favori puis dupliquez-le (engrenage en haut à droite). <b>Vous pourrez
            ensuite comparer les 2 scénarios entre eux</b>.
        </p>
    </div>
</ng-template>

<!-- KPI sans valeur : tiret simple, sans badge -->
<ng-template #noValueTpl><p class="value-empty">-</p></ng-template>
